import React, { useState, useCallback, useRef } from "react";
import styles from "./ImageCropper.module.scss";
import UploadHelper from "../../helpers/upload";
import { base64toFile, image64toCanvasRef } from "../../helpers/imageCropperHelper";
import ReactCrop from 'react-image-crop';
import 'react-image-crop/lib/ReactCrop.scss';
import { Button, Classes, Dialog, Intent } from "@blueprintjs/core";

const ImageCropper = ({
  onImageSelect,
  setLoading = () => {},
  loading,
  children
}) => {
  const inputId = `imageInput${Math.random()}`;
  const defaultCropState = {
    unit: '%',
    width: 50,
    height: 50,
    x: 25,
    y: 25,
    aspect: 1
  };

  const [imgRef, setImgRef] = useState(null);
  const [file, setFile] = useState();
  const [openModal, setOpenModal] = useState(false);
  const canvasRef = useRef(null);
  const [crop, setCrop] = useState(defaultCropState);

  const onImageChange = async (file) => {
    setLoading(true);
    if (file) {
      const { url, signedUrl } = await UploadHelper.getSignedUrl(
        UploadHelper.PRODUCT_IMAGE,
        {
          contentType: file.type
        }
      );
      await UploadHelper.uploadToS3(signedUrl, file, () => {});
      onImageSelect(url);
    }
    setLoading(false);
    setOpenModal(false);
  };

  const onCropComplete = async (crop) => {
    if(imgRef) {
      const croppedBase64Image = await image64toCanvasRef(canvasRef.current, imgRef, crop, file);
      const croppedImage = base64toFile(croppedBase64Image, file.name);
      await onImageChange(croppedImage)
    }
  };

  const onSelectFile = (event) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = () => setFile({
        base64: reader.result,
        name: files[0].name || '',
        type: files[0].type || ''
    });

      setOpenModal(true);
    }
  };

  const onImageLoaded = useCallback(img => {
    setImgRef(img);
  }, []);

  return (
    <>
      <label htmlFor={inputId}>{children}</label>
      <Dialog
        icon="dollar"
        isOpen={openModal}
        canOutsideClickClose={!loading}
        canEscapeKeyClose={!loading}
      >
        <div className={Classes.DIALOG_BODY}>
          <ReactCrop
            src={file ? file.base64 : ''}
            crop={crop}
            className={styles.cropperPreview}
            onChange={(crop) => {setCrop(crop)}}
            onImageLoaded={onImageLoaded}
          />

          <canvas
            ref={canvasRef}
            className={styles.hiddenInput}
          />
        </div>

        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button
              text="Cancel"
              type="button"
              minimal
              disabled={loading}
              onClick={() => {
                setOpenModal(false);
                setCrop(defaultCropState);
              }}
              intent={Intent.NONE}
            />
            <Button
              text="Crop"
              loading={loading}
              onClick={() => onCropComplete(crop)}
              disabled={!crop.width}
              intent={Intent.PRIMARY}
            />
          </div>
        </div>
      </Dialog>

      <input
        className={styles.hiddenInput}
        type="file"
        accept="image/*"
        required
        id={inputId}
        onChange={onSelectFile}
        onClick={(e) => e.target.value = null}
      />
    </>
  );
};

export default ImageCropper;
